import * as React from "react"

function OverviewIcon(props) {
  return (
  	<svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
	  <path className="fill" opacity="0.2" d="M15 15H6.5L6.5 6.5L15 6.5V15Z" strokeWidth={2} />
	  <path d="M25.5 5.5H6.5C5.94772 5.5 5.5 5.94772 5.5 6.5V25.5C5.5 26.0523 5.94772 26.5 6.5 26.5H25.5C26.0523 26.5 26.5 26.0523 26.5 25.5V6.5C26.5 5.94772 26.0523 5.5 25.5 5.5Z" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
	  <path d="M16 5.5V26.5" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
	  <path d="M26.5 16H5.5" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
	</svg>
  )
}

export default OverviewIcon